import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import './static/css/style.css';
import './static/css/customer.css';

import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
